import React, { useState, useEffect } from 'react';
import { Box, Divider, Snackbar, Alert } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Hero from '../marketing-page/components/Hero';
import LogoCollection from '../marketing-page/components/LogoCollection';
import Features from '../marketing-page/components/Features';
import Testimonials from '../marketing-page/components/Testimonials';
import Highlights from '../marketing-page/components/Highlights';
import Pricing from '../marketing-page/components/Pricing';
import FAQ from '../marketing-page/components/FAQ';
import SiteFooter from '../components/SiteFooter';

export default function HomePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [notice, setNotice] = useState('');

  useEffect(() => {
    if (location.state?.message) {
      setNotice(location.state.message);
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return (
    <>
      <Snackbar
        open={!!notice}
        autoHideDuration={4000}
        onClose={() => setNotice('')}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setNotice('')}
          severity="info"
          sx={{ width: '100%', fontWeight: 'bold' }}
        >
          {notice}
        </Alert>
      </Snackbar>
      <Box sx={{ width: '100%', mx: -3 }}>
        <Hero />
        <Box>
        {/* <LogoCollection /> */}
        {/* <Features />
        <Divider /> */}
        {/* <Testimonials /> */}
        {/* <Divider /> */}
        {/* <Highlights />
        <Divider /> */}
        {/* <Pricing />
        <Divider /> */}
        {/* <FAQ /> */}
        {/* <Divider /> */}
        <SiteFooter />
      </Box>
    </Box>
    </>
  );
}
